import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPwawifi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={116} height={101} fill='none' {...props}>
    <g clipPath='url(#pwawifi_svg__a)'>
      <path
        fill='#F23645'
        d='M115.268 23.82c-.134 1.406-.306 2.808-.398 4.218-.859 13.369-1.705 26.74-2.558 40.11-.08 1.257-.187 2.51-.284 3.812H96.424l-3.22-49.933h22.063v1.793z'
      />
      <path
        fill='var(--blue-1-active)'
        d='M85.745 15.059c.263 4.188.515 8.161.764 12.136-26.269-8.082-49.514-3.036-69.698 15.547L.731 26.662C28.186-2.056 76.584-8.914 112.786 15.06zM25.652 53.158c5.059-5.248 10.812-9.27 17.407-11.996 13.753-5.684 27.565-5.718 41.371-.12 3.14 1.273 3.092 1.28 3.29 4.69.354 6.109.754 12.217 1.184 18.323.053.758-.16 1.25-.677 1.758-.977.965-1.888 1.997-2.888 3.068-6.185-5.98-13.394-9.003-21.76-8.914-8.322.09-15.446 3.218-21.383 9.18L25.652 53.16zM63.862 100.499c-7.246-.02-13.11-5.898-13.093-13.125.018-7.199 5.96-13.112 13.157-13.089 7.185.024 13.063 5.892 13.057 13.04-.006 7.37-5.807 13.192-13.12 13.174'
      />
      <path
        fill='#F23645'
        d='M113.767 89.642c-.004 5.284-4.272 9.552-9.532 9.532-5.274-.02-9.59-4.323-9.562-9.534.028-5.246 4.336-9.548 9.566-9.558 5.233-.008 9.532 4.306 9.528 9.56'
      />
    </g>
    <defs>
      <clipPath id='pwawifi_svg__a'>
        <path fill='#fff' d='M.732.5h114.537v100H.732z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPwawifi;
